"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _TitleInput = _interopRequireDefault(require("../../preact-components/title-input/TitleInput"));

var _BetaBadge = _interopRequireDefault(require("../ui-components/BetaBadge"));

var Header = function Header(_ref) {
  var isCustomView = _ref.isCustomView,
      title = _ref.title,
      onTitleChanged = _ref.onTitleChanged,
      customButtons = _ref.customButtons,
      _ref$isBeta = _ref.isBeta,
      isBeta = _ref$isBeta === void 0 ? false : _ref$isBeta,
      customViewActions = _ref.customViewActions,
      titleLinks = _ref.titleLinks;
  return (0, _preact.h)("div", null, (0, _preact.h)("div", {
    className: "control-header"
  }, isCustomView ? (0, _preact.h)(_TitleInput.default, {
    title: title,
    onTitleChanged: onTitleChanged
  }) : (0, _preact.h)("h2", {
    className: "control-header__title"
  }, title, titleLinks && titleLinks, isBeta && (0, _preact.h)(_BetaBadge.default, null)), customViewActions, customButtons && (0, _preact.h)("div", {
    className: "control-header__action-buttons"
  }, customButtons)));
};

var _default = Header;
exports.default = _default;